import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button } from 'Components/ui'

const Panel = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  background: var(--vo-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  padding: 16px 20px;
  margin-bottom: 20px;
`

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 160px;
  flex: 1 1 160px;
`

const ItemLabel = styled.label`
  font-family: var(--font-secondary);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--vo-slate);
`

const Spacer = styled.div`
  flex: 1 1 0;
`

const FilterPanelItem = ({ label, children }) => (
  <ItemWrapper>
    {label && <ItemLabel>{label}</ItemLabel>}
    {children}
  </ItemWrapper>
)

FilterPanelItem.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export const FilterPanel = ({ children, onClear, clearLabel }) => (
  <Panel>
    {children}
    {onClear && (
      <>
        <Spacer />
        <Button
          variant="text"
          type="button"
          onClick={onClear}
          sx={{
            fontFamily: 'var(--font-secondary)',
            fontSize: '13px',
            fontWeight: 500,
            color: 'var(--vo-slate)',
            padding: '4px 8px',
            alignSelf: 'flex-end',
            minHeight: 0,
            height: 'auto',
            '&:hover': { color: 'var(--color-brand)', backgroundColor: 'transparent', boxShadow: 'none' },
          }}
        >
          {clearLabel || 'Limpar filtros'}
        </Button>
      </>
    )}
  </Panel>
)

FilterPanel.Item = FilterPanelItem

FilterPanel.propTypes = {
  children: PropTypes.node.isRequired,
  onClear: PropTypes.func,
  clearLabel: PropTypes.string,
}
